angular.module("app").constant("releaseServers",{
    web: [
        'builder',
        'lux1',
        'bme01',
        'blot',
        'vbetfr',
        'ggnet',
        'lux2',
        'web01CN',
        'dlv',
        'misc1',
        'misc2',
        'web01a-hk',
        'belarus-front-gcb',
        'web-cn',
        'mobile-01lx',
        'mobile-02lx',
    ],
    mobile: [
        'mobile-01lx',
        'mobile-02lx',
        'bme01',
        'web01a-tw',
        'belarus-front-gcb',
        'web-cn'
    ],
    webDefault: "lux1",
    mobileDefault: "mobile-01lx"
} );
